import { render, staticRenderFns } from "./EllipsisMenu.vue?vue&type=template&id=125542e8&scoped=true&"
import script from "./EllipsisMenu.vue?vue&type=script&lang=js&"
export * from "./EllipsisMenu.vue?vue&type=script&lang=js&"
import style0 from "./EllipsisMenu.vue?vue&type=style&index=0&id=125542e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125542e8",
  null
  
)

export default component.exports